import { Injectable } from '@angular/core';
import { JhiLanguageService } from 'ng-jhipster';

import { Account, Credentials, ExternalAuthenticationData } from '../models';
import { AuthenticationJwtService } from '../shared';
import { Principal } from './principal.service';

@Injectable()
export class LoginService {

    constructor(private languageService: JhiLanguageService,
                private principal: Principal,
                private authenticationJwtService: AuthenticationJwtService) {
    }

    private reloadAccount(account: Account) {
        /* After the log-in the language will be changed to
         * the language selected by the user during his registration
         * */
        if (account != null && account.langKey != null) {
            this.languageService.changeLanguage(account.langKey);
        }
    }

    public login(credentials: Credentials) {
        return new Promise((resolve, reject) => {
            this.authenticationJwtService.login(credentials).subscribe((data) => {
                this.principal.identity(true)
                    .then(this.reloadAccount.bind(this))
                    .then(() => {
                        resolve(data);
                    });
            }, (error) => {
                this.logout();
                reject(error);
            });
        });
    }

    public loginWithToken(jwt: any, rememberMe: boolean) {
        return this.authenticationJwtService.loginWithToken(jwt, rememberMe);
    }

    public loginExternal(externalAuthenticationData: ExternalAuthenticationData) {
        return new Promise((resolve, reject) => {
            this.authenticationJwtService.loginExternal(externalAuthenticationData).subscribe((data) => {
                this.principal.identity(true)
                    .then(this.reloadAccount.bind(this))
                    .then(() => {
                        resolve(data);
                    });
            }, (error) => {
                this.logout();
                reject(error);
            });
        });
    }

    public logout() {
        this.authenticationJwtService.logout().subscribe();
        this.principal.authenticate(null);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/services/login.service.ts